import type { SVGProps } from "react";
export default function SvgDocumentAnalysisAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={97.9492} height={120} x={-10.5767} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_649_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_649)">
				<path
					fill="url(#paint0_linear_1110_649)"
					fillOpacity={0.6}
					d="M64.097 14H12.698c-2.913 0-5.275 2.352-5.275 5.254v73.492c0 2.902 2.362 5.254 5.275 5.254h51.4c2.913 0 5.274-2.352 5.274-5.254V19.254c0-2.902-2.361-5.254-5.275-5.254"
				/>
				<path
					stroke="url(#paint1_linear_1110_649)"
					d="M12.699 14.5h51.398c2.64 0 4.775 2.13 4.776 4.754v73.492c0 2.624-2.137 4.754-4.776 4.754H12.7c-2.64 0-4.775-2.13-4.776-4.754V19.254c0-2.624 2.137-4.754 4.776-4.754Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M56.107 40.507H20.652a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h35.455c1.237 0 2.24.998 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<path
				fill="#FAFF00"
				d="M56.107 54.422H20.652a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h35.455c1.237 0 2.24.998 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<path
				fill="#FAFF00"
				d="M39.251 68.338h-18.6a2.235 2.235 0 0 1-2.24-2.232 2.235 2.235 0 0 1 2.24-2.231h18.6c1.238 0 2.24.999 2.24 2.231a2.235 2.235 0 0 1-2.24 2.232"
			/>
			<foreignObject width={101.517} height={101.521} x={21.0601} y={10.8037}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_649_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_649)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M103.402 87.504 86.669 70.77a25.7 25.7 0 0 0 3.117-5.513 26.2 26.2 0 0 0 1.998-9.445v-.64c0-3.468-.672-6.888-1.998-10.1a26.2 26.2 0 0 0-5.722-8.55 26.4 26.4 0 0 0-8.55-5.722 26.7 26.7 0 0 0-9.445-1.997h-.64c-3.467 0-6.903.67-10.1 1.997a26.4 26.4 0 0 0-8.55 5.722 26.4 26.4 0 0 0-5.721 8.55 26.4 26.4 0 0 0-1.998 10.1v.64c.08 3.244.767 6.456 1.998 9.445a26.4 26.4 0 0 0 5.721 8.55 26.2 26.2 0 0 0 8.55 5.721 26.288 26.288 0 0 0 20.185 0 26.3 26.3 0 0 0 5.514-3.1L97.76 93.16a3.994 3.994 0 1 0 5.641-5.657m-30.94-15.358a18.288 18.288 0 0 1-14.064 0 18.15 18.15 0 0 1-5.961-3.98 18.5 18.5 0 0 1-3.996-5.96 18.8 18.8 0 0 1-1.374-6.138v-.895a18 18 0 0 1 1.374-7.032 18.2 18.2 0 0 1 3.996-5.96 18.271 18.271 0 0 1 12.993-5.386h.895c2.11.127 4.187.59 6.137 1.39a18.5 18.5 0 0 1 5.96 3.995 18.15 18.15 0 0 1 3.98 5.961 18 18 0 0 1 1.375 6.121l.032.911c0 2.413-.48 4.795-1.407 7.032a18.5 18.5 0 0 1-3.98 5.961 18.5 18.5 0 0 1-5.96 3.98"
				/>
				<path
					stroke="url(#paint2_linear_1110_649)"
					strokeOpacity={0.5}
					d="M65.43 29.304h.627l.596.021c2.976.143 5.905.806 8.67 1.938a25.9 25.9 0 0 1 8.387 5.613l.002.002a25.7 25.7 0 0 1 5.36 7.802l.252.585a25.9 25.9 0 0 1 1.96 9.908v.64a25.7 25.7 0 0 1-1.96 9.252v.001c-.8 1.93-1.82 3.748-3.056 5.407l-.258.346 17.038 17.038a3.493 3.493 0 0 1 0 4.95c-1.354 1.355-3.564 1.357-4.936-.001L81.078 75.772l-.346.254a25.8 25.8 0 0 1-5.41 3.041 25.8 25.8 0 0 1-19.801 0 25.7 25.7 0 0 1-8.387-5.612h-.002a26 26 0 0 1-5.361-7.805l-.251-.584a26.1 26.1 0 0 1-1.939-8.67l-.02-.596v-.627c0-3.403.658-6.757 1.959-9.908a25.94 25.94 0 0 1 14.001-14.001 25.9 25.9 0 0 1 9.91-1.96Zm18.88 25.86-.002-.009-.031-.91-.001-.006a18.5 18.5 0 0 0-1.413-6.29 18.7 18.7 0 0 0-3.763-5.793l-.325-.33a19 19 0 0 0-6.121-4.102l-.003-.001-.377-.15a19.8 19.8 0 0 0-5.919-1.278h-.925a18.8 18.8 0 0 0-6.795 1.255l-.428.173a18.7 18.7 0 0 0-6.123 4.102 18.7 18.7 0 0 0-3.921 5.697l-.184.428a18.5 18.5 0 0 0-1.41 6.762l-.002.46v.923c.116 2.165.591 4.297 1.412 6.3l.001.002a19 19 0 0 0 4.102 6.12v.002a18.65 18.65 0 0 0 6.124 4.087v.001a18.8 18.8 0 0 0 14.447 0 19 19 0 0 0 6.124-4.088 19 19 0 0 0 4.087-6.122 18.9 18.9 0 0 0 1.445-7.224z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1110_649"
					x1={38.5558}
					x2={38.5558}
					y1={14}
					y2={98}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_649"
					x1={38.3978}
					x2={1.54643}
					y1={14.9199}
					y2={75.3165}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_649"
					x1={71.8184}
					x2={71.8184}
					y1={28.8037}
					y2={94.3241}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_649_clip_path" transform="translate(10.577 4)">
					<path d="M64.097 14H12.698c-2.913 0-5.275 2.352-5.275 5.254v73.492c0 2.902 2.362 5.254 5.275 5.254h51.4c2.913 0 5.274-2.352 5.274-5.254V19.254c0-2.902-2.361-5.254-5.275-5.254" />
				</clipPath>
				<clipPath id="bgblur_1_1110_649_clip_path" transform="translate(-21.06 -10.804)">
					<path d="M103.402 87.504 86.669 70.77a25.7 25.7 0 0 0 3.117-5.513 26.2 26.2 0 0 0 1.998-9.445v-.64c0-3.468-.672-6.888-1.998-10.1a26.2 26.2 0 0 0-5.722-8.55 26.4 26.4 0 0 0-8.55-5.722 26.7 26.7 0 0 0-9.445-1.997h-.64c-3.467 0-6.903.67-10.1 1.997a26.4 26.4 0 0 0-8.55 5.722 26.4 26.4 0 0 0-5.721 8.55 26.4 26.4 0 0 0-1.998 10.1v.64c.08 3.244.767 6.456 1.998 9.445a26.4 26.4 0 0 0 5.721 8.55 26.2 26.2 0 0 0 8.55 5.721 26.288 26.288 0 0 0 20.185 0 26.3 26.3 0 0 0 5.514-3.1L97.76 93.16a3.994 3.994 0 1 0 5.641-5.657m-30.94-15.358a18.288 18.288 0 0 1-14.064 0 18.15 18.15 0 0 1-5.961-3.98 18.5 18.5 0 0 1-3.996-5.96 18.8 18.8 0 0 1-1.374-6.138v-.895a18 18 0 0 1 1.374-7.032 18.2 18.2 0 0 1 3.996-5.96 18.271 18.271 0 0 1 12.993-5.386h.895c2.11.127 4.187.59 6.137 1.39a18.5 18.5 0 0 1 5.96 3.995 18.15 18.15 0 0 1 3.98 5.961 18 18 0 0 1 1.375 6.121l.032.911c0 2.413-.48 4.795-1.407 7.032a18.5 18.5 0 0 1-3.98 5.961 18.5 18.5 0 0 1-5.96 3.98" />
				</clipPath>
				<filter
					id="filter0_i_1110_649"
					width={97.9492}
					height={120}
					x={-10.5767}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_649" />
				</filter>
				<filter
					id="filter1_i_1110_649"
					width={101.517}
					height={101.521}
					x={21.0601}
					y={10.8037}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_649" />
				</filter>
			</defs>
		</svg>
	);
}
